import {
  ACCOUNT_AGENCY,
  ACCOUNT_EDITOR,
  ACCOUNT_HOUSE_SPEAKER,
  congRoles,
  SUPER_ADMIN_ACCOUNTS,
} from "utility/constants";
import React from "react";
import { getFormattedContactNumber } from "utility/helpers";
import { ALLOCATION_STATUS, ALLOCATION_STATUS_OPTIONS } from "constants/status";

export const getStatusOptionsPosition = (initialProjects, editingRowId) => {
  if (initialProjects?.length === 1) {
    return "bottom";
  }

  if (
    editingRowId === initialProjects.length - 1 &&
    initialProjects?.length > 3
  ) {
    return "top";
  }

  return "bottom";
};

export const canEditRow = (status, role) => {
  let canEdit = false;

  if (
    role === ACCOUNT_EDITOR &&
    (status === ALLOCATION_STATUS.PENDING ||
      status === ALLOCATION_STATUS.REQUESTED ||
      status === ALLOCATION_STATUS.DISAPPROVED)
  ) {
    canEdit = true;
  } else if (
    SUPER_ADMIN_ACCOUNTS.includes(role) &&
    status !== ALLOCATION_STATUS.NOTELIGIBLE
  ) {
    canEdit = true;
  } else if (
    role === ACCOUNT_AGENCY &&
    status !== ALLOCATION_STATUS.DISAPPROVED &&
    status !== ALLOCATION_STATUS.PENDING &&
    status !== ALLOCATION_STATUS.NOTELIGIBLE
  ) {
    canEdit = true;
  } else if (
    congRoles.includes(role) &&
    (status === ALLOCATION_STATUS.REQUESTED ||
      status === ALLOCATION_STATUS.RESUBMISSION ||
      status === ALLOCATION_STATUS.DISAPPROVED)
  ) {
    canEdit = true;
  }

  return canEdit;
};

export const cannotEditStatus = (status, role) => {
  let cannotEdit = true;

  if (
    SUPER_ADMIN_ACCOUNTS.includes(role) &&
    status !== ALLOCATION_STATUS.PROCESSED &&
    status !== ALLOCATION_STATUS.INPROGRESS &&
    status !== ALLOCATION_STATUS.DOWNLOADED
  ) {
    cannotEdit = false;
  } else if (
    role === ACCOUNT_AGENCY &&
    status !== ALLOCATION_STATUS.DISAPPROVED &&
    status !== ALLOCATION_STATUS.PENDING
  ) {
    cannotEdit = false;
  } else if (
    role === ACCOUNT_EDITOR &&
    (status === ALLOCATION_STATUS.REQUESTED ||
      status === ALLOCATION_STATUS.PENDING ||
      status === ALLOCATION_STATUS.DISAPPROVED)
  ) {
    cannotEdit = false;
  } else if (
    role === ACCOUNT_HOUSE_SPEAKER &&
    status === ALLOCATION_STATUS.PENDING
  ) {
    cannotEdit = false;
  }

  return cannotEdit;
};

const EDITOR_STATUS_OPTIONS = [
  ALLOCATION_STATUS.REQUESTED,
  ALLOCATION_STATUS.PENDING,
  ALLOCATION_STATUS.DISAPPROVED,
];

const HOUSE_SPEAKER_STATUS_OPTIONS = [
  ALLOCATION_STATUS.APPROVED,
  ALLOCATION_STATUS.PENDING,
];

const APPROVED_AGENCY_STATUS_OPTIONS = [
  ALLOCATION_STATUS.PROCESSED,
  ALLOCATION_STATUS.DOWNLOADED,
  ALLOCATION_STATUS.RESUBMISSION,
  ALLOCATION_STATUS.NOTELIGIBLE,
];

const NOT_APPROVED_AGENCY_STATUS_OPTIONS = [
  ALLOCATION_STATUS.PROCESSED,
  ALLOCATION_STATUS.DOWNLOADED,
  ALLOCATION_STATUS.APPROVED,
];

const APPROVED_DIRECTOR_STATUS_OPTIONS = [
  ALLOCATION_STATUS.APPROVED,
  ALLOCATION_STATUS.PENDING,
  ALLOCATION_STATUS.DISAPPROVED,
  ALLOCATION_STATUS.RESUBMISSION,
  ALLOCATION_STATUS.NOTELIGIBLE,
];

const NOT_APPROVED_DIRECTOR_STATUS_OPTIONS = [
  ALLOCATION_STATUS.APPROVED,
  ALLOCATION_STATUS.PENDING,
  ALLOCATION_STATUS.DISAPPROVED,
];

export const getStatusOptions = (status, role) => {
  let options = ALLOCATION_STATUS_OPTIONS;

  if (SUPER_ADMIN_ACCOUNTS.includes(role)) {
    if (status === ALLOCATION_STATUS.APPROVED) {
      options = options?.filter((option) =>
        APPROVED_DIRECTOR_STATUS_OPTIONS.includes(option.value)
      );
    } else {
      options = options?.filter((option) =>
        NOT_APPROVED_DIRECTOR_STATUS_OPTIONS.includes(option.value)
      );
    }
  }

  if (role === ACCOUNT_AGENCY) {
    if (status === ALLOCATION_STATUS.APPROVED) {
      options = options?.filter((option) =>
        APPROVED_AGENCY_STATUS_OPTIONS.includes(option.value)
      );
    } else {
      options = options?.filter((option) =>
        NOT_APPROVED_AGENCY_STATUS_OPTIONS.includes(option.value)
      );
    }
  }

  if (role === ACCOUNT_EDITOR) {
    options = options?.filter((option) =>
      EDITOR_STATUS_OPTIONS.includes(option.value)
    );
  }

  if (role === ACCOUNT_HOUSE_SPEAKER) {
    options = options?.filter((option) =>
      HOUSE_SPEAKER_STATUS_OPTIONS.includes(option.value)
    );
  }

  return options;
};

export const validate = (selectedDistrict, selectedRegion, tempCongDetails) => {
  if (
    selectedDistrict === null &&
    selectedRegion !== null &&
    tempCongDetails?.District?.RegionId !== selectedRegion?.id
  ) {
    return "Required district";
  }

  if (
    selectedDistrict !== null &&
    selectedRegion === null &&
    selectedDistrict?.RegionId !== tempCongDetails?.District?.RegionId
  ) {
    return "Required region";
  }

  if (
    tempCongDetails?.contact &&
    !/^(09)\d{9}$/.test(getFormattedContactNumber(tempCongDetails?.contact))
  ) {
    return "Invalid congressman mobile number";
  }

  if (
    tempCongDetails?.cosContact &&
    !/^(09)\d{9}$/.test(getFormattedContactNumber(tempCongDetails?.cosContact))
  ) {
    return "Invalid cos mobile number";
  }

  return true;
};

export const getIndex = (property, logs) =>
  logs?.findIndex((log) => log.data[property]);

export const getDropdownSelectOptions = (data) => {
  const options =
    data?.map((select) => ({
      ID: select?.id,
      Name: select?.name,
      acronym: select?.acronym,
      displayLabel: (
        <div className="d-flex align-items-center">
          <img
            height="70px"
            width="70px"
            src={select.photo}
            alt="party-logo"
            className="mr-1"
          />
          <h5 className="font-weight-bold mb-0">{`${select?.name} (${select?.acronym})`}</h5>
        </div>
      ),
      label: (
        <h5 className="font-weight-bold mb-0">{`${select?.name} (${select?.acronym})`}</h5>
      ),
      photo: select?.photo,
    })) || [];

  return options;
};
